<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 25%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
  margin-bottom: 0px;
}
input {
  padding-top: 1px;
  padding-bottom: 1px;
}
.fixHeightScrollable {
  overflow: auto;
  min-height: 200px;
  max-height: 500px;
}
hr {
  border: none;
  height: 0.5px;
  /* Set the hr color */
  color: #ccc; /* old IE */
  background-color: #ccc; /* Modern Browsers */
}
.row-collapse {
  visibility: collapse;
}
label {
  width: 100%;
  padding-bottom: 0px;
  margin-bottom: 0px;
  float: none;
}
.full-width {
	float: none;
  width: 100% !important;
}
</style>
<style>
input[readonly] {
    background-color: lightgray;
    color: blue;
}
</style>
<template>
  <div>
    <b-form :validated="true">
      <div class="d-flex justify-content-between">
        <h4>Health, Safety, and Environment</h4>
        <div>
          <DxButton
            icon="save"
            hint="Save HSE report"
            :height="40"
            :disabled="editable"
            @click="onSubmit" />
          <DxButton
            icon="download"
            hint="Download HSE excel file"
            :height="40"
            />
          <DxButton
            id="refreshButton"
            icon="revert"
            hint="Refresh"
            :height="40"
            @click="refresh" />
        </div>
      </div>
    <br />
      <b-progress
        height="1px"
        :value="progressLoading"
        variant="success"
      ></b-progress>
    <table>
      <tr>
        <td class="d-flex pt-3 pb-1" @click="pdData.collapsed = !pdData.collapsed">
          <h5 align="left"> 
          <span>
            <b-icon v-show="!pdData.collapsed" scale="1" icon="chevron-bar-contract" class="show-content" />
            <b-icon v-show="pdData.collapsed" scale="1" icon="chevron-bar-expand" class="hide-content" />
          </span>
          Personnel Data
          </h5>
        <span>
          <b-icon v-show="pdData.mandatory" icon="check-circle" variant="success" />
          <b-icon v-show="!pdData.mandatory" icon="exclamation-circle" variant="danger" />
        </span>
        </td>
      </tr>
      <tr :class="{ 'row-collapse': pdData.collapsed }">
        <td>
          <span v-show="hseId < 0">Fill and submit the following form first</span>
          <DxDataGrid
            id="report-grid"
            ref="reportGrid"
            width="100%"
            height="200"
            :data-source="hsePersonnelDataSource"
            :show-borders="false"
            :show-column-lines="false"
            :show-row-lines="true"
            column-resize-mode="nextColumn"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :cell-hint-enabled="true"
            :word-wrap-enabled="true"
            :column-auto-width="false"
            :visible="hseId > 0"
            @row-inserted="onRowInserted"
            @row-updated="onRowUpdated"
            @row-removed="onRowRemoved"
          >
            <DxPaging :enabled="true" :page-size="5" />
            <DxSelection mode="single"/>
            <DxScrolling />
            <DxEditing
                :allow-updating="editable"
                :allow-adding="editable"
                :allow-deleting="editable"
                :use-icons="true"
                mode="row"/>
            <DxColumn
              type="buttons"
              width="5%"
            >
              <GridButton name="edit"/>
              <GridButton name="delete"/>
            </DxColumn>
            <DxColumn caption="No." cell-template="rowNoTemplate" width="5%" />
            <template #rowNoTemplate="{ data }">
              {{ data.rowIndex + 1 }}
            </template>
            <DxColumn
              data-field="companyName"
              caption="Company Name"
              width="20%"
            >
                <DxRequiredRule :message="requiredMessage"/>
            </DxColumn>
            <DxColumn
              data-field="noOfPeople"
              caption="No. of People"
              width="10%"
            >
                <DxRequiredRule :message="requiredMessage"/>
            </DxColumn>
            <DxColumn
              data-field="remarks"
              caption="Remarks"
            />
        </DxDataGrid>
        </td>
      </tr>
      <tr>
        <td class="d-flex pt-3 pb-1" @click="spData.collapsed = !spData.collapsed">
          <h5 align="left"> 
          <span>
            <b-icon v-show="!spData.collapsed" scale="1" icon="chevron-bar-contract" class="show-content" />
            <b-icon v-show="spData.collapsed" scale="1" icon="chevron-bar-expand" class="hide-content" />
          </span>
          Safety Performance 
          </h5>
        <!-- span>
          <b-icon v-show="spData.mandatory" icon="check-circle" variant="success" />
          <b-icon v-show="!spData.mandatory" icon="exclamation-circle" variant="danger" />
        </span -->
        </td>
      </tr>
      <tr :class="{ 'row-collapse': spData.collapsed }">
        <td class="d-flex justify-content-between">
          <b-row>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-last-mti" class="dx-field-label">Last MTI</label>
                <div class="dx-field-value full-width">
                  <DxDateBox
                    v-model="form.lastMTI" name="input-last-mti" date-serialization-format="yyyy-MM-dd" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-last-lti" class="dx-field-label">Last LTI</label>
                <div class="dx-field-value full-width">
                  <DxDateBox
                    v-model="form.lastLTI" name="input-last-lti" date-serialization-format="yyyy-MM-dd" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-dwlti" class="dx-field-label">Days without LTI (DWLTI)</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="daysWithoutLti" name="input-dwlti" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-dwlti-since" class="dx-field-label">DWLTI Since</label>
                <div class="dx-field-value full-width">
                  <DxDateBox
                    v-model="form.dwlti" name="input-dwlti-since" date-serialization-format="yyyy-MM-dd" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-daily-safe-work-hours" class="dx-field-label">Daily Safe Workforce Hours</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.dailySafeWorkHours" name="input-daily-safe-work-hours" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-cum-safe-work-hours" class="dx-field-label">Cumulated Safe Workforce Hours</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.cumSafeWorkHours" name="input-cum-safe-work-hours" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
          </b-row>
        </td>
      </tr>
      <tr>
        <td class="d-flex pt-3 pb-1" @click="liData.collapsed = !liData.collapsed">
          <h5 align="left"> 
          <span>
            <b-icon v-show="!liData.collapsed" scale="1" icon="chevron-bar-contract" class="show-content" />
            <b-icon v-show="liData.collapsed" scale="1" icon="chevron-bar-expand" class="hide-content" />
          </span>
          Leading Indicator 
          </h5>
        <!-- span>
          <b-icon v-show="liData.mandatory" icon="check-circle" variant="success" />
          <b-icon v-show="!liData.mandatory" icon="exclamation-circle" variant="danger" />
        </span -->
        </td>
      </tr>
      <tr>
        <td><strong>HSE Program</strong></td>
      </tr>
      <tr :class="{ 'row-collapse': liData.collapsed }">        
        <td class="d-flex justify-content-between">
          <b-row>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-hse-induction" class="dx-field-label">HSE Inductions</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.hseInduction" name="input-hse-induction" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-hse-meetings" class="dx-field-label">HSE Meetings/Tail Gate Meetings</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.hseMeeting" name="input-hse-meetings" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-weekly-meetings" class="dx-field-label">Weekly Meetings</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.weeklyMeeting" name="input-weekly-meetings" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-prejob-meetings" class="dx-field-label">Pre-job Safety Meetings</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.preJobSafetyMeeting" name="input-prejob-meetings" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-safety-stand-downs" class="dx-field-label">Safety Stand Downs</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.safetyStandDown" name="input-safety-stand-downs" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-permit-towork" class="dx-field-label">Permit to Work</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.permitToWork" name="input-permit-towork" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-job-safety" class="dx-field-label">Job Safety Analysis</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.jobSafetyAnalysis" name="input-job-safety" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-management-visits" class="dx-field-label">Management Visits</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.managementVisits" name="input-management-visits" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-safety-campaigns" class="dx-field-label">Safety Campaigns</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.safetyCampaign" name="input-safety-campaigns" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-noise-measurements" class="dx-field-label">Noise Measurements</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.noiseMeasurement" name="input-noise-measurements" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-hoc" class="dx-field-label">Hazard Observation Cards(HOC)</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.hoc" name="input-hoc" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
          </b-row>
        </td>
      </tr>
      <tr>
        <td><strong>HSE Trainings</strong></td>
      </tr>
      <tr :class="{ 'row-collapse': liData.collapsed }">
        <td class="d-flex justify-content-between">
          <b-row>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-medivac-trainings" class="dx-field-label">Medivac Trainings</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.medivacTraining" name="input-medivac-trainings" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-h2s-drills" class="dx-field-label">H<sub>2</sub>S Drill</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.h2sDrill" name="input-h2s-drills" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-kick-drills" class="dx-field-label">Kick/Blowout/Trip Drills</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.kick" name="input-kick-drills" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-evacuation-trainings" class="dx-field-label">Abandon Evacuation Trainings</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.evacuationTraining" name="input-evacuation-trainings" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-fire-eq-trainings" class="dx-field-label">Fire Equipment Trainings</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.fireEquipmentTraining" name="input-fire-eq-trainings" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-first-aid-trainings" class="dx-field-label">First Aid/Medical Treatment Trainings</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.firstAidTraining" name="input-first-aid-trainings" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-apd-trainings" class="dx-field-label">APD Trainings</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.apdTraining" name="input-apd-trainings" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-oil-spill-drills" class="dx-field-label">Oil Spill Drills</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.oilSpillDrill" name="input-oil-spill-drills" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-accident-prevention" class="dx-field-label">Accident Prevention</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.accidentPrevention" name="input-accident-prevention" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-lifting-riggings" class="dx-field-label">Lifting Riggings</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.liftingRigging" name="input-lifting-riggings" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-basic-trainings" class="dx-field-label">Basic Safety Trainings</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.basicSafetyTraining" name="input-basic-trainings" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
          </b-row>
        </td>
      </tr>
      <tr>
        <td class="d-flex pt-3 pb-1" @click="lagData.collapsed = !lagData.collapsed">
          <h5 align="left"> 
          <span>
            <b-icon v-show="!lagData.collapsed" scale="1" icon="chevron-bar-contract" class="show-content" />
            <b-icon v-show="lagData.collapsed" scale="1" icon="chevron-bar-expand" class="hide-content" />
          </span>
          Lagging Indicator 
          </h5>
        <!-- span>
          <b-icon v-show="lagData.mandatory" icon="check-circle" variant="success" />
          <b-icon v-show="!lagData.mandatory" icon="exclamation-circle" variant="danger" />
        </span -->
        </td>
      </tr>
      <tr :class="{ 'row-collapse': lagData.collapsed }">
        <td class="d-flex justify-content-between">
          <b-row>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-nearmiss-incidents" class="dx-field-label">Nearmiss Incidents</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.nearMissIncidents" name="input-nearmiss-incidents" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-firstaid-incidents" class="dx-field-label">First Aid Incidents</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.firstAidIncidents" name="input-firstaid-incidents" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-medical-treatment-incidents" class="dx-field-label">Medical Treatment Incidents</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.medicalTreatmentIncident" name="input-medical-treatment-incidents" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-restricted-work-incidents" class="dx-field-label">Restricted Work Incidents</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.restrictedWorkIncident" name="input-restricted-work-incidents" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-lost-time-incidents" class="dx-field-label">Lost Time Incidents</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.lostTimeIncident" name="input-lost-time-incidents" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-fatality-incidents" class="dx-field-label">Fatality Incidents</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.fatalityIncident" name="input-fatality-incidents" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-property-damage-incidents" class="dx-field-label">Property Damage Incidents</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.propertyDamageIncident" name="input-property-damage-incidents" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-vehicle-incidents" class="dx-field-label">Vehicle Incidents</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.vehicleIncident" name="input-vehicle-incidents" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-illness-incidents" class="dx-field-label">Occupation Illness Incidents</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.occupationIllnessIncident" name="input-illness-incidents" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
          </b-row>
        </td>
      </tr>
      <tr>
        <td class="d-flex pt-3 pb-1" @click="testData.collapsed = !testData.collapsed">
          <h5 align="left"> 
          <span>
            <b-icon v-show="!testData.collapsed" scale="1" icon="chevron-bar-contract" class="show-content" />
            <b-icon v-show="testData.collapsed" scale="1" icon="chevron-bar-expand" class="hide-content" />
          </span>
          Test 
          </h5>
        <!-- span>
          <b-icon v-show="testData.mandatory" icon="check-circle" variant="success" />
          <b-icon v-show="!testData.mandatory" icon="exclamation-circle" variant="danger" />
        </span -->
        </td>
      </tr>
      <tr :class="{ 'row-collapse': testData.collapsed }">
        <td class="d-flex justify-content-between">
          <b-row>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-last-casing-pressure-test" class="dx-field-label">Last Casing Pressure Test</label>
                <div class="dx-field-value full-width">
                  <DxDateBox
                    v-model="form.lastCasingPressureTest" name="input-last-casing-pressure-test" date-serialization-format="yyyy-MM-dd" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-last-bop-test" class="dx-field-label">Last BOP Test</label>
                <div class="dx-field-value full-width">
                  <DxDateBox
                    v-model="form.lastBOPTest" name="input-last-bop-test" date-serialization-format="yyyy-MM-dd" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-next-bop-test" class="dx-field-label">Next BOP Test</label>
                <div class="dx-field-value full-width">
                  <DxDateBox
                    v-model="form.nextBOPTest" name="input-next-bop-test" date-serialization-format="yyyy-MM-dd" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
          </b-row>
        </td>
      </tr>
      <tr>
        <td class="d-flex pt-3 pb-1" @click="commentData.collapsed = !commentData.collapsed">
          <h5 align="left"> 
          <span>
            <b-icon v-show="!commentData.collapsed" scale="1" icon="chevron-bar-contract" class="show-content" />
            <b-icon v-show="commentData.collapsed" scale="1" icon="chevron-bar-expand" class="hide-content" />
          </span>
          Comments
          </h5>
        <!-- span>
          <b-icon v-show="commentData.mandatory" icon="check-circle" variant="success" />
          <b-icon v-show="!commentData.mandatory" icon="exclamation-circle" variant="danger" />
        </span -->
        </td>
      </tr>
      <tr :class="{ 'row-collapse': commentData.collapsed }">
        <td class="d-flex justify-content-between">
          <b-row>
            <b-col cols="12">
              <div class="dx-field">
                <label for="input-safety-comments" class="dx-field-label">Safety Comments</label>
                <div class="dx-field-value full-width">
                  <DxTextArea
                    v-model="form.safetyComments" name="input-safety-comments" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="12">
              <div class="dx-field">
                <label for="input-community-issues" class="dx-field-label">Community/Security/Logistic Issues</label>
                <div class="dx-field-value full-width">
                  <DxTextArea
                    v-model="form.community" name="input-community-issues" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
          </b-row>
        </td>
      </tr>
      <tr>
        <td class="d-flex pt-3 pb-1" @click="eaData.collapsed = !eaData.collapsed">
          <h5 align="left"> 
          <span>
            <b-icon v-show="!eaData.collapsed" scale="1" icon="chevron-bar-contract" class="show-content" />
            <b-icon v-show="eaData.collapsed" scale="1" icon="chevron-bar-expand" class="hide-content" />
          </span>
          Environmental Activity
          </h5>
        <!-- span>
          <b-icon v-show="eaData.mandatory" icon="check-circle" variant="success" />
          <b-icon v-show="!eaData.mandatory" icon="exclamation-circle" variant="danger" />
        </span -->
        </td>
      </tr>
      <tr :class="{ 'row-collapse': eaData.collapsed }">
        <td class="d-flex justify-content-between">
          <b-row>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-cutting-volume" class="dx-field-label">Cutting Volume</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.cuttingVolume" name="input-cutting-volume" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-hazardous-waste" class="dx-field-label">Hazardous Waste</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.hazardousWaste" name="input-hazardous-waste" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-spill-volume" class="dx-field-label">Spill Incident Volume</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.spillIncidentVolume" name="input-spill-volume" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="dx-field">
                <label for="input-other-waste-volume" class="dx-field-label">Other Waste Volume</label>
                <div class="dx-field-value full-width">
                  <DxNumberBox
                    v-model="form.otherWasteVolume" name="input-other-waste-volume" :disabled="!editable"
                  />
                </div>
              </div>
            </b-col>
          </b-row>
        </td>
      </tr>
    </table>
    </b-form>
  </div>                      
</template>
<script>
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import { formMethods, formComputed, authComputed } from '@state/helpers'
import { BootstrapVue, BootstrapVueIcons, BIconUpload } from 'bootstrap-vue'
import axios from 'axios'
import qs from 'querystring'
import notify from "devextreme/ui/notify"
import DxButton from 'devextreme-vue/button'
// import { DxForm, DxSimpleItem } from 'devextreme-vue/form'
import DxTextArea from 'devextreme-vue/text-area'
// import DxTextBox from 'devextreme-vue/text-box'
import DxDateBox from 'devextreme-vue/date-box'
import {
  DxRequiredRule,
} from 'devextreme-vue/validator'
import { DxNumberBox } from 'devextreme-vue/number-box'
import {
  DxDataGrid,
  DxColumn,
  DxSelection,
  DxEditing,
  DxScrolling,
  DxButton as GridButton
} from 'devextreme-vue/data-grid'
import mapApiUrl from '@/src/utils/api-mapper'
import CustomStore from 'devextreme/data/custom_store'


Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.component('BIconUpload', BIconUpload)
Vue.use(VueFormGenerator)

export default {
  components: {
    DxButton,
    DxRequiredRule,
    DxNumberBox,
    DxTextArea,
    DxDateBox,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxSelection,
    DxScrolling,
    GridButton
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    submitId: {
        type: Number,
        default: 0,
    },
    editable: {
        type: Boolean,
        default: false,
    },
    wellId: {
        type: Number,
        default: 0,
    },
    lastSubmitId: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      form: {},
      // daysWithoutLti: 0,
      hseId: -1,
      hsePersonnelData: [],
      hsePersonnelDataSource: null,
      show: true,
      reportIsLoading: false,
      progressLoading: 0,
      optionsComboHoleSize: [],
      hasData: false,
      editableOps: this.editable,
      files: [],
      showOptionContigency: false,
      fileNameUpload: '',
      fileUpload: '',
      requiredMessage: 'This value is required',
      loadingOn: false,
      spData: {collapsed: true, mandatory: true},
      liData: {collapsed: true, mandatory: true},
      lagData: {collapsed: true, mandatory: true},
      testData: {collapsed: true, mandatory: true},
      pdData: {collapsed: true, mandatory: false},
      commentData: {collapsed: true, mandatory: true},
      eaData: {collapsed: true, mandatory: true},
    }
  },
  computed: {
    ...formComputed,
    ...authComputed,
    daysWithoutLti: function() {
      if (this.form.lastLTI === undefined) return 0
      const today = new Date()
      const lastLTI = new Date(this.form.lastLTI)
      const span = (today.getTime() - lastLTI.getTime()) / (24*3600000)
      return Math.floor(span) 
    }
  },
  watch: {
    submitId: function (value) {
      this.refreshForm()
    },
    editable: function (val) {
      this.editableOps = val
    },
    hseId() {
      // this.hsePersonnelDataSource.load()
      this.$refs.reportGrid.instance.refresh()
    }
  },
  created: function () {
    this.init()
    this.refreshForm()
  },
  methods: {
    ...formMethods,
    init() {
      this.hseId = null
      this.form = {}
      this.hsePersonnelData = {}
      
      this.hsePersonnelDataSource = new CustomStore({
        key: 'id',
        load: () => {
          if (this.hseId === null) return
          const url = mapApiUrl('/api/form/master/hse/personnel/list')
          return fetch(url + `?hseId=${this.hseId}`, {
                    method: 'GET',
                    headers: { 'Authorization': 'Bearer ' + this.currentUser.token,
                               'Content-Type': 'application/json'
                      }})
            // .then(handleErrors)
            .then(response => response.json())
            .catch(() => { throw new Error('Network error') })
        },
        onLoaded: function(result) {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0]);
            }
        },
        insert: (values) => {
          if (isNaN(values.id)) {
            delete values.id
          }
          values.hseId = this.hseId
          const url = mapApiUrl('/api/form/master/hse/personnel/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        update: (key, values) => {
          values.id = key
          const url = mapApiUrl('/api/form/master/hse/personnel/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        remove: (key) => {
        const url = mapApiUrl('/api/form/master/hse/personnel/delete')
          return fetch(url + `?id=${key}`, {
                    method: 'DELETE',
                    headers: { 'Authorization': 'Bearer ' + this.currentUser.token,
                               'Content-Type': 'application/json'
                      }})
            // .then(handleErrors)
            .then(response => { 
                if (!response.ok) throw new Error('Network error') })
        },
      })

    },
    personalDataMandatoryCheck() {
      this.pdData.mandatory = this.hsePersonnelDataSource.totalCount() > 0
    },
    onRowRemoved(e) {
      notify({ message: 'Bit data has been removed.', width: 500 }, 'success', 3000)
    },
    onRowInserted(e) {
      notify({ message: 'Bit data has been recorded.', width: 500 }, 'success', 3000)
    },
    onRowUpdated(e) {
      notify({ message: 'Bit data has been updated.', width: 500 }, 'success', 3000)
    },
    refresh() {
      this.$refs.reportGrid.instance.refresh()
      this.refreshForm()
    },
    refreshForm() {
      this.hseId = null
      this.form = {}
      const url = mapApiUrl('/api/form/master/hse/get')
      let params={submitId: this.submitId}
      this.reportIsLoading = true
      axios
      .get(url, {
        params: params
      })
      .then((response) => {
        this.reportIsLoading = false
        if (response.data) {
          this.form = {...response.data}
          this.hseId = this.form.id
          // this.getPersonnelData()
        } 
        this.personalDataMandatoryCheck()
      })
    },
    getPersonnelData() {
      const url = mapApiUrl('/api/form/master/hse/personnel/list')
      let params={hseId: this.hseId}
      this.reportIsLoading = true
      axios
      .get(url, {
        params: params
      })
      .then((response) => {
        this.reportIsLoading = false
        if (response.data) {
          this.hsePersonnelData = response.data
        }
      })
    },
    getHSECarryOver() {
      const url = mapApiUrl('/api/form/master/hse/get')
      let params={submitId: this.lastSubmitId}
      this.reportIsLoading = true
      axios
      .get(url, {
        params: params
      })
      .then((response) => {
        this.reportIsLoading = false
        if (response.data) {
          this.form.lastMTI = response.data.lastMTI
          this.form.lastLTI = response.data.lastLTI
          this.form.dwlti = response.data.dwlti 
          this.form.dailySafeWorkHours = response.data.dailySafeWorkHours
          this.form.cumSafeWorkHours = response.data.cumSafeWorkHours
          this.form.nearMissIncidents = response.data.nearMissIncidents
          this.form.firstAidIncidents = response.data.firstAidIncidents
          this.form.medicalTreatmentIncident = response.data.medicalTreatmentIncident
          this.form.restrictedWorkIncident = response.data.restrictedWorkIncident
          this.form.lostTimeIncident = response.data.lostTimeIncident
          this.form.fatalityIncident = response.data.fatalityIncident
          this.form.propertyDamageIncident = response.data.propertyDamageIncident
          this.form.vehicleIncident = response.data.vehicleIncident
          this.form.occupationIllnessIncident = response.data.occupationIllnessIncident
          this.form.lastCasingPressureTest = response.data.lastCasingPressureTest
          this.form.lastBOPTest = response.data.lastBOPTest
          this.form.nextBOPTest = response.data.nextBOPTest
          this.form.companyName = response.data.companyName
          this.form.noOfPeople = response.data.noOfPeople
          this.form.remarks = response.data.remarks
        }
      })
    },
    onSubmit() {
      this.form.submitId = this.submitId
      this.form.dailyReportId = this.submitId
      const url = mapApiUrl('/api/form/master/hse/add')
      this.reportIsLoading = true
      axios.post(url, qs.stringify(this.form)).then((response) => {
        this.reportIsLoading = false
        // this.refreshForm()
        notify({ message: 'HSE data has been recorded.', width: 500 }, 'success', 3000)
      })
    },
    onReset() {
      this.form = {}
    },            
    saveRows(e) {
      notify({ message: 'Personnel data has been recorded.', width: 500 }, 'success', 3000)
      /* let rowData = {}
      if (Array.isArray(e.changes)) {
        rowData = {...e.changes[0].data}        
      } else {
        rowData = {...e.changes.data}
      }
      rowData.hseId = this.hseId

      if (isNaN(rowData.id)) {
        delete rowData.id
      }
      const url = mapApiUrl('/api/form/master/hse/personnel/add')
      this.reportIsLoading = true
      axios.post(url, qs.stringify(rowData)).then((response) => {
        this.reportIsLoading = false
        this.hseId = response.data.id
        notify({ message: 'Personnel data has been recorded.', width: 500 }, 'success', 3000)
      }) */
    },          
  }
}
</script>

    <!-- div class="d-flex justify-content-between">
        <div class="d-flex" @click='spData.collapsed = !spData.collapsed'>
            <h5 align="left">
              <span>
                <b-icon v-show="!spData.collapsed" icon="chevron-bar-contract" class="show-content" />
                <b-icon v-show="spData.collapsed" icon="chevron-bar-expand" class="hide-content" />
              </span>
                Safety Performance
            </h5>
            <span>
                <b-icon v-show="spData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!spData.mandatory" icon="exclamation-circle" variant="danger" />
          </span>
        </div>
        <div v-show="false">
          <span class="border border-primary p-1">
            <b-icon v-show="spData.mandatory" icon="check-circle" variant="success" />
            <b-icon v-show="!spData.mandatory" icon="exclamation-circle" variant="danger" />
            Mandatory data
          </span>              
        </div>
    </div>
    <br />
    <div v-show="!spData.collapsed" class="fixHeightScrollable">
      <!- DxForm
        :form-data="form"
        :col-count="2">
        <DxSimpleItem data-field="lastMTI" caption="Last MTI:" editor-type="dxDateBox" />
        <DxSimpleItem data-field="lastLTI" caption="Last LTI:" editor-type="dxDateBox"/>
        <DxSimpleItem data-field="daysWithoutLti" caption="Days without LTI:"/>
        <DxSimpleItem data-field="dwlti" caption="DWLTI Since:" editor-type="dxDateBox" />
        <DxSimpleItem data-field="dailySafeWorkHours" caption="Daily Safe Workforce Hours:"/>
        <DxSimpleItem data-field="cumSafeWorkHours" caption="Cumulated Safe Workforce Hours:"/>        
      </DxForm ->
      <b-form-group
              id="input-group-last-mti"
              label="Last MTI:"
              label-for="input-last-mti"
            ><b-form-input
                id="input-last-mti"
                v-model="form.lastMTI"
                type="date"
                placeholder="Enter last MTI"
                :disabled="!editableOps"
              ></b-form-input>
            </b-form-group>
      <b-form-group
              id="input-group-last-lti"
              label="Last LTI:"
              label-for="input-last-lti"
            ><b-form-input
                id="input-last-lti"
                v-model="form.lastLTI"
                type="date"
                placeholder="Enter last LTI"
                :disabled="!editableOps"
              ></b-form-input>
            </b-form-group>
      <b-form-group
              id="input-group-days-without-lti"
              label="Days without LTI:"
              label-for="input-days-without-lti"
            ><b-form-input
                id="input-days-without-lti"
                v-model="daysWithoutLti"
                type="number"
                placeholder="Enter days without LTI"
                readonly
                :disabled="!editableOps"
              ></b-form-input>
            </b-form-group>
      <b-form-group
              id="input-group-dwlti-since"
              label="DWLTI Since:"
              label-for="input-dwlti-since"
            ><b-form-input
                id="input-dwlti-since"
                v-model="form.dwlti"
                type="date"
                placeholder="Enter date of DLWTI"
                :disabled="!editableOps"
              ></b-form-input>
            </b-form-group>
      <b-form-group
              id="input-group-daily-safe-workforce-hours"
              label="Daily Safe Workforce Hours:"
              label-for="input-daily-safe-workforce-hours"
            ><b-form-input
                id="input-daily-safe-workforce-hours"
                v-model="form.dailySafeWorkHours"
                type="number"
                placeholder="Enter daily safe workforce hours"
                :disabled="!editableOps"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-cumm-safe-workforce-hours"
              label="Cumm. Safe Workforce Hours:"
              label-for="input-cumm-safe-workforce-hours"
            ><b-form-input
                id="input-cumm-safe-workforce-hours"
                v-model="form.cumSafeWorkHours"
                type="number"
                placeholder="Enter cummulative safe workforce hours"
                :disabled="!editableOps"
              ></b-form-input>
            </b-form-group>
    </div>
    <div class="d-flex justify-content-between">
        <div class="d-flex" @click='liData.collapsed = !liData.collapsed'>
            <h5 align="left">
              <span>
                <b-icon v-show="!liData.collapsed" icon="chevron-bar-contract" class="show-content" />
                <b-icon v-show="liData.collapsed" icon="chevron-bar-expand" class="show-content" />
              </span>
                Leading Indicator 
            </h5>
            <span>
                <b-icon v-show="liData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!liData.mandatory" icon="exclamation-circle" variant="danger" />
          </span>
        </div>
        <div v-show="false">
          <span class="border border-primary p-1">
            <b-icon v-show="liData.mandatory" icon="check-circle" variant="success" />
            <b-icon v-show="!liData.mandatory" icon="exclamation-circle" variant="danger" />
            Mandatory data
          </span>
        </div>
    </div>
    <br />
    <div v-show="!liData.collapsed" class="fixHeightScrollable">
          <br />
          <h6>
              HSE Program
          </h6>
      <!- DxForm
        :form-data="form"
        :col-count="2">
          <DxSimpleItem data-field="hseInduction" caption="HSE Induction:" location="top" editor-type="dxNumberBox" />
          <DxSimpleItem data-field="hseMeeting" caption="HSE Meetings:" editor-type="dxNumberBox" />
          <DxSimpleItem data-field="weeklyMeeting" caption="Weekly Meetings:" editor-type="dxNumberBox" />
          <DxSimpleItem data-field="preJobSafetyMeeting" caption="Pre Job Safety Meetings:" editor-type="dxNumberBox" />
          <DxSimpleItem data-field="safetyStandDown" caption="Safety Standdowns:" editor-type="dxNumberBox" />
          <DxSimpleItem data-field="permitToWork" caption="Permit to Work:" editor-type="dxNumberBox" />
          <DxSimpleItem data-field="jobSafetyAnalysis" caption="Job Safety Analysis:" editor-type="dxNumberBox" />
          <DxSimpleItem data-field="managementVisits" caption="Management Visits:" editor-type="dxNumberBox" />
          <DxSimpleItem data-field="safetyCampaign" caption="Safety Campaigns:" editor-type="dxNumberBox" />
          <DxSimpleItem data-field="noiseMeasurement" caption="Noise Measurements:" editor-type="dxNumberBox" />
          <DxSimpleItem data-field="hoc" caption="Hazard Observation Card (HOC):" editor-type="dxNumberBox" />
      </DxForm ->
          <b-form-group
            id="input-group-hse-introduction"
            label="HSE Induction:"
            label-for="input-hse-introduction">
            <b-form-input
                id="input-hse-introduction"
                v-model="form.hseInduction"
                type="number"
                placeholder="Enter HSE introduction"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-hse-meeting"
            label="HSE/Tail Gate Meetings:"
            label-for="input-hse-meeting">
            <b-form-input
                id="input-hse-meeting"
                v-model="form.hseMeeting"
                type="number"
                placeholder="Enter HSE / Tail Gate meetings"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-weekly-meeting"
            label="Weekly Meetings:"
            label-for="input-weekly-meeting">
            <b-form-input
                id="input-weekly-meeting"
                v-model="form.weeklyMeeting"
                type="number"
                placeholder="Enter weekly meetings"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-pre-job-safety-meeting"
            label="Pre-job Safety Meetings:"
            label-for="input-pre-job-safety-meeting">
            <b-form-input
                id="input-pre-job-safety-meeting"
                v-model="form.preJobSafetyMeeting"
                type="number"
                placeholder="Enter pre-job safety meetings"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-safety-standdown"
            label="Safety Standdowns:"
            label-for="input-safety-standdown">
            <b-form-input
                id="input-safety-standdown"
                v-model="form.safetyStandDown"
                type="number"
                placeholder="Enter safety standowns"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-permit-to-work"
            label="Permit to Work:"
            label-for="input-permit-to-work">
            <b-form-input
                id="input-permit-to-work"
                v-model="form.permitToWork"
                type="number"
                placeholder="Enter permit to work"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-job-safety-analysis"
            label="Job Safety Analysis:"
            label-for="input-job-safety-analysis">
            <b-form-input
                id="input-job-safety-analysis"
                v-model="form.jobSafetyAnalysis"
                type="number"
                placeholder="Enter job safety analysis"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-management-visit"
            label="Management Visits:"
            label-for="input-management-visits">
            <b-form-input
                id="input-management-visits"
                v-model="form.managementVisits"
                type="number"
                placeholder="Enter management visits"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-safety-campaign"
            label="Safety Campaigns:"
            label-for="input-safety-campaigns">
            <b-form-input
                id="input-safety-campaigns"
                v-model="form.safetyCampaign"
                type="number"
                placeholder="Enter safety campaigns"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-noise-measurements"
            label="Noise Measurements:"
            label-for="input-noise-measurements">
            <b-form-input
                id="input-noise-measurements"
                v-model="form.noiseMeasurement"
                type="number"
                placeholder="Enter noise measurements"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-hazard-observation-cards"
            label="Hazard Observation Card (HOC):"
            label-for="input-hoc">
            <b-form-input
                id="input-hoc"
                v-model="form.hoc"
                type="number"
                placeholder="Enter hazard observation cards"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <h6>
            HSE Training
          </h6>
              <b-form-group
              id="input-group-medivac-training"
              label="Medivac Trainings:"
              label-for="input-medivac-training">
              <b-form-input
                  id="input-medivac-training"
                  v-model="form.medivacTraining"
                  type="number"
                  placeholder="Enter medivac trainings"
                  :disabled="!editableOps">
              </b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-h2s-drill"
              label="H2S Drill:"
              label-for="input-h2s-drill">
              <b-form-input
                  id="input-h2s-drill"
                  v-model="form.h2sDrill"
                  type="number"
                  placeholder="Enter H2S drill"
                  :disabled="!editableOps">
              </b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-kick-blowout-trip-drill"
              label="Kick/Blowout/Trip Drill:"
              label-for="input-kick-blowout-trip-drill">
              <b-form-input
                  id="input-kick-blowout-trip-drill"
                  v-model="form.kick"
                  type="number"
                  placeholder="Enter kick/blowout/trip drill"
                  :disabled="!editableOps">
              </b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-abandon-evacuation-training"
              label="Abandon Evacuation Training:"
              label-for="input-abandon-evacuation-training">
              <b-form-input
                  id="input-abandon-evacuation-training"
                  v-model="form.evacuationTraining"
                  type="number"
                  placeholder="Enter abandon evacuation training"
                  :disabled="!editableOps">
              </b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-fire-equipment-training"
              label="Fire Equipment Training:"
              label-for="input-fire-equipment-training">
              <b-form-input
                  id="input-fire-equipment-training"
                  v-model="form.fireEquipmentTraining"
                  type="number"
                  placeholder="Enter fire equipment training"
                  :disabled="!editableOps">
              </b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-first-aid-training"
              label="First Aid/Medical Treatment Training:"
              label-for="input-first-aid-training">
              <b-form-input
                  id="input-first-aid-training"
                  v-model="form.firstAidTraining"
                  type="number"
                  placeholder="Enter first aid / medical treatment training"
                  :disabled="!editableOps">
              </b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-apd-training"
              label="APD Training:"
              label-for="input-apd-training">
              <b-form-input
                  id="input-apd-training"
                  v-model="form.apdTraining"
                  type="number"
                  placeholder="Enter APD training"
                  :disabled="!editableOps">
              </b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-oil-spill-drill"
              label="Oil Spill Drill:"
              label-for="input-oil-spill-drill">
              <b-form-input
                  id="input-oil-spill-drill"
                  v-model="form.oilSpillDrill"
                  type="number"
                  placeholder="Enter oil spill drill"
                  :disabled="!editableOps">
              </b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-accident-prevention"
              label="Accident Prevention:"
              label-for="input-accident-prevention">
              <b-form-input
                  id="input-accident-prevention"
                  v-model="form.accidentPrevention"
                  type="number"
                  placeholder="Enter accident prevention"
                  :disabled="!editableOps">
              </b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-lifting-rigging"
              label="Lifting Rigging:"
              label-for="input-lifting-rigging">
              <b-form-input
                  id="input-lifting-rigging"
                  v-model="form.liftingRigging"
                  type="number"
                  placeholder="Enter lifting rigging"
                  :disabled="!editableOps">
              </b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-basic-safety-training"
              label="Basic Safety Training:"
              label-for="input-basic-safety-training">
              <b-form-input
                  id="input-basic-safety-training"
                  v-model="form.basicSafetyTraining"
                  type="number"
                  placeholder="Enter basic safety training"
                  :disabled="!editableOps">
              </b-form-input>
            </b-form-group>
    </div>
    <div class="d-flex justify-content-between">
        <div class="d-flex" @click='lagData.collapsed = !lagData.collapsed'>
            <h5 align="left">
                <span>
                    <b-icon v-show="!lagData.collapsed" icon="chevron-bar-contract" class="show-content" />
                    <b-icon v-show="lagData.collapsed" icon="chevron-bar-expand" class="hide-content" />
                </span>
                Lagging Indicator 
            </h5>
            <span>
                <b-icon v-show="lagData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!lagData.mandatory" icon="exclamation-circle" variant="danger" />
          </span>
        </div>
        <div v-show="false">
          <span class="border border-primary p-1">
            <b-icon v-show="lagData.mandatory" icon="check-circle" variant="success" />
            <b-icon v-show="!lagData.mandatory" icon="exclamation-circle" variant="danger" />
            Mandatory data
          </span>
        </div>
    </div>
    <br />
    <div v-show="!lagData.collapsed" class="fixHeightScrollable">
          <b-form-group
            id="input-group-nearmiss-incident"
            label="Nearmiss Incident:"
            label-for="input-nearmiss-incident">
            <b-form-input
                id="input-nearmiss-incident"
                v-model="form.nearMissIncidents"
                type="number"
                placeholder="Enter nearmiss incident"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-first-aid-incident"
            label="First Aid Incident:"
            label-for="input-first-aid-incident">
            <b-form-input
                id="input-first-aid-incident"
                v-model="form.firstAidIncidents"
                type="number"
                placeholder="Enter first aid incident"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-medical-treatment-incident"
            label="Medical Treatment Incident:"
            label-for="input-medical-treatment-incident">
            <b-form-input
                id="input-medical-treatment-incident"
                v-model="form.medicalTreatmentIncident"
                type="number"
                placeholder="Enter medical treatment incident"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-restricted-work-incident"
            label="Restricted Work Incident:"
            label-for="input-restricted-work-incident">
            <b-form-input
                id="input-restricted-work-incident"
                v-model="form.restrictedWorkIncident"
                type="number"
                placeholder="Enter restricted work incident"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-lost-time-incident"
            label="Lost Time Incident:"
            label-for="input-lost-time-incident">
            <b-form-input
                id="input-lost-time-incident"
                v-model="form.lostTimeIncident"
                type="number"
                placeholder="Enter lost time incident"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-fatality-incident"
            label="Fatality Incident:"
            label-for="input-fatality-incident">
            <b-form-input
                id="input-fatality-incident"
                v-model="form.fatalityIncident"
                type="number"
                placeholder="Enter fatality incidents"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-property-damage-incident"
            label="Property Damage Incident:"
            label-for="input-property-damage-incident">
            <b-form-input
                id="input-property-damage-incident"
                v-model="form.propertyDamageIncident"
                type="number"
                placeholder="Enter property damage incident"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-vehicle-incident"
            label="Vehicle Incident:"
            label-for="input-vehicle-incident">
            <b-form-input
                id="input-vehicle-incident"
                v-model="form.vehicleIncident"
                type="number"
                placeholder="Enter vehicle incident"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-occupation-illness-incident"
            label="Occupation Illness Incident:"
            label-for="input-occupation-illness-incident">
            <b-form-input
                id="input-occupation-illness-incident"
                v-model="form.occupationIllnessIncident"
                type="number"
                placeholder="Enter occupation illness incident"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
    </div>
    <div class="d-flex justify-content-between">
        <div class="d-flex" @click='testData.collapsed = !testData.collapsed'>
            <h5 align="left">
                <span>
                    <b-icon v-show="!testData.collapsed" icon="chevron-bar-contract" class="show-content" />
                    <b-icon v-show="testData.collapsed" icon="chevron-bar-expand" class="hide-content" />
                </span>
                Test 
            </h5>
            <span>
                <b-icon v-show="testData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!testData.mandatory" icon="exclamation-circle" variant="danger" />
            </span>
        </div>
        <div v-show="false">
            <span class="border border-primary p-1">
                <b-icon v-show="testData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!testData.mandatory" icon="exclamation-circle" variant="danger" />
                Mandatory data
            </span>
        </div>
    </div>
    <br />
    <div v-show="!testData.collapsed" class="fixHeightScrollable">
          <b-form-group
            id="input-group-last-casing-pressure-test"
            label="Last Casing Pressure Test:"
            label-for="last-casing-pressure-test">
            <b-form-input
                id="last-casing-pressure-test"
                v-model="form.lastCasingPressureTest"
                type="date"
                placeholder="Enter last casing pressure test date"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-last-bop-test"
            label="Last BOP Test:"
            label-for="last-bop-test">
            <b-form-input
                id="last-bop-test"
                v-model="form.lastBOPTest"
                type="date"
                placeholder="Enter last BOP test date"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-next-bop-test"
            label="Next BOP Test:"
            label-for="next-bop-test">
            <b-form-input
                id="next-bop-test"
                v-model="form.nextBOPTest"
                type="date"
                placeholder="Enter next BOP test date"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
    </div>
    <div class="d-flex justify-content-between">
        <div class="d-flex" @click='pdData.collapsed = !pdData.collapsed'>
            <h5 align="left">
              <span>
                <b-icon v-show="!pdData.collapsed" icon="chevron-bar-contract" class="show-content" />
                <b-icon v-show="pdData.collapsed" icon="chevron-bar-expand" class="hide-content" />
              </span>
                Personnel Data
            </h5>
            <span>
                <b-icon v-show="pdData.mandatory" icon="check-circle" ariant="success" />
                <b-icon v-show="!pdData.mandatory" icon="exclamation-circle" variant="danger" />
          </span>
        </div>
        <div v-show="false">
          <span class="border border-primary p-1">
            <b-icon v-show="pdData.mandatory" icon="check-circle" ariant="success" />
            <b-icon v-show="!pdData.mandatory" icon="exclamation-circle" variant="danger" />
            Mandatory data
          </span>
          
        </div>
    </div>
    <br />
    <div v-show="!pdData.collapsed" class="fixHeightScrollable">
          <b-form-group
            id="input-group-company-name"
            label="Company Name:"
            label-for="company-name">
            <b-form-input
                id="company-name"
                v-model="form.companyName"
                type="text"
                placeholder="Enter company name"
                required
                :disabled="!editableOps"
                >
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-no-of-people"
            label="No. of People:"
            label-for="no-of-people">
            <b-form-input
                id="no-of-people"
                v-model="form.noOfPeople"
                type="number"
                placeholder="Enter number of people"
                required
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-remarks"
            label="Remarks:"
            label-for="remarks"
            style="width: 100%">
            <b-form-input
                id="remarks"
                v-model="form.remarks"
                type="text"
                placeholder="Enter remarks"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
    </div>
    <div class="d-flex justify-content-between">
        <div class="d-flex" @click='commentData.collapsed = !commentData.collapsed'>
            <h5 align="left">
                <span>
                    <b-icon v-show="!commentData.collapsed" icon="chevron-bar-contract" class="show-content" />
                    <b-icon v-show="commentData.collapsed" icon="chevron-bar-expand" class="hide-content" />
                </span>
                Comments
            </h5>
            <span>
                <b-icon v-show="commentData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!commentData.mandatory" icon="exclamation-circle" variant="danger" />
          </span>
        </div>
        <div v-show="false">
          <span class="border border-primary p-1">
            <b-icon v-show="commentData.mandatory" icon="check-circle" variant="success" />
            <b-icon v-show="!commentData.mandatory" icon="exclamation-circle" variant="danger" />
            Mandatory data
          </span>
        </div>
    </div>
    <br />
    <div v-show="!commentData.collapsed" class="fixHeightScrollable">
          <b-form-group
            id="input-group-safety-comments"
            label="Safety Comments:"
            label-for="safety-comments"
            style="width: 100%">
            <b-form-input
                id="safety-comments"
                v-model="form.safetyComments"
                type="text"
                placeholder="Enter safety comments"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-issues"
            label="Community/Security/Logistics Issues:"
            label-for="issues"
            style="width: 100%">
            <b-form-input
                id="issues"
                v-model="form.community"
                type="text"
                placeholder="Enter community/security/logistics issues"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
    </div>
    <div class="d-flex justify-content-between">
        <div class="d-flex" @click='eaData.collapsed = !eaData.collapsed'>
            <h5 align="left">
              <span>
                <b-icon v-show="!eaData.collapsed" icon="chevron-bar-contract" class="show-content" />
                <b-icon v-show="eaData.collapsed" icon="chevron-bar-expand" class="hide-content" />
              </span>
                Environmental Activity
            </h5>
            <span>
                <b-icon v-show="eaData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!eaData.mandatory" icon="exclamation-circle" variant="danger" />
          </span>
        </div>
        <div v-show="false">
          <span class="border border-primary p-1">
            <b-icon v-show="eaData.mandatory" icon="check-circle" variant="success" />
            <b-icon v-show="!eaData.mandatory" icon="exclamation-circle" variant="danger" />
            Mandatory data
          </span>
        </div>
    </div>
    <br />
    <div v-show="!eaData.collapsed" class="fixHeightScrollable">
          <b-form-group
            id="input-group-cutting-volume"
            label="Cutting Volume:"
            label-for="cutting-volume">
            <b-form-input
                id="cutting-volume"
                v-model="form.cuttingVolume"
                type="number"
                placeholder="Enter cutting volume"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-hazardous-waste"
            label="Hazardous Waste:"
            label-for="hazardous-waste">
            <b-form-input
                id="cutting-volume"
                v-model="form.hazardousWaste"
                type="number"
                placeholder="Enter hazardous waste"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-spill-incident-volume"
            label="Spill Incident Volume:"
            label-for="cutting-volume">
            <b-form-input
                id="spill-incident-volume"
                v-model="form.spillIncidentVolume"
                type="number"
                placeholder="Enter spill incident volume"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-other-waste-volume"
            label="Other Waste Volume:"
            label-for="other-waste-volume">
            <b-form-input
                id="other-waste-volume"
                v-model="form.otherWasteVolume"
                type="number"
                placeholder="Enter other waste volume"
                :disabled="!editableOps">
            </b-form-input>
          </b-form-group>
    </div-->
                      
